/**
 * Exports a boolean value reporting whether the given API is supported or not
 */
export const isAPISupported = (api) => (api in window);
